import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials'
})
export class InitialsPipe implements PipeTransform {

  transform(name: string): any {
    if (name) {
      const splittedName = name.split(' ');
      return `${splittedName[0][0].toUpperCase()}${splittedName[1][0].toUpperCase()}`
    }
    return '';
  }
}
